import { call, cancelled } from 'redux-saga/effects';
import request from 'utils/request';


export function* cancellableRequest(url, options = {}) {
  const controller = new AbortController();
  try {
    return yield call(request, url, { ...options, signal: controller.signal });
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}


export const isAbortError = (err) =>
  err?.name === 'AbortError' || err?.code === 20;

export default cancellableRequest;
